/* PureBrush — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.pb-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('pb-visible');
        if (e.target.hasAttribute('data-pb-count')) countUp(e.target);
        e.target.querySelectorAll('[data-pb-count]').forEach(countUp);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    if (el.dataset.pbDone) return;
    el.dataset.pbDone = '1';
    var target = parseFloat(el.getAttribute('data-pb-count')) || 0;
    if (reduce) { el.textContent = target; return; }
    var start = null, dur = 1400;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    // Garantía: si el navegador frena la animación, deja siempre la cifra final
    setTimeout(function () { el.textContent = target; }, dur + 300);
  }

  function initParallax() {
    var frames = document.querySelectorAll('[data-pb-parallax]');
    if (!frames.length || reduce) return;
    var ticking = false;
    function update() {
      frames.forEach(function (f) {
        var k = parseFloat(f.getAttribute('data-pb-parallax')) || 0;
        var r = f.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        f.style.setProperty('--pb-parallax', off.toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initGallery() {
    document.querySelectorAll('[data-pb-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-pb-main]');
      if (!main) return;
      g.querySelectorAll('[data-pb-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          g.querySelectorAll('[data-pb-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = btn.getAttribute('data-src');
            main.alt = btn.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 150);
        });
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-pb-product]').forEach(function (root) {
      var json = root.querySelector('[data-pb-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-pb-price]');
      var oldEl = root.querySelector('[data-pb-old]');
      var btn = root.querySelector('[data-pb-add]');
      var fmt = root.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
      function money(cents) {
        var v = (cents / 100).toFixed(2);
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          return k.indexOf('comma') > -1 ? v.replace('.', ',') : v;
        });
      }
      root.addEventListener('change', function (e) {
        if (!e.target.closest('.pb-option')) return;
        var chosen = Array.prototype.map.call(root.querySelectorAll('.pb-option'), function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (oldEl) {
          oldEl.hidden = !(v.compare_at_price > v.price);
          oldEl.textContent = v.compare_at_price ? money(v.compare_at_price) : '';
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
        }
      });
    });
  }

  function init() { initReveal(); initParallax(); initGallery(); initVariants(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
